import React from 'react';
import ProjectsUI from '../core-ui/projects/projects-UI';

const Projects = () => <ProjectsUI />;

export default Projects;
